import React from 'react';
import { Crosshair } from 'lucide-react';

/**
 * Bottom-right crosshair button that re-centres the map on the guest.
 * Only rendered when the map is expanded. Parent owns the geolocation
 * retry + easeTo logic inside `useGuestMapInstance`.
 */
export function MapCenterOnMeButton({ onClick, navOffset }) {
  return (
    <button
      type="button"
      onClick={(event) => { event.stopPropagation(); onClick(); }}
      data-testid="map-center-btn"
      style={{
        position: 'absolute',
        bottom: `calc(env(safe-area-inset-bottom, 0px) + ${navOffset + 24}px)`,
        right: 16,
        zIndex: 1000,
        width: 44,
        height: 44,
        borderRadius: '50%',
        backgroundColor: 'var(--surface)',
        border: '1px solid var(--card-border)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: 'var(--premium-shadow-nested)',
      }}
    >
      <Crosshair size={22} color="var(--accent-purple-strong)" />
    </button>
  );
}
